module.exports = __webpack_public_path__ + "img/amazon.9ad4960a.svg";